export const getBgColorCO2 = (value: string) => {
  const parseVal = +value

  if (parseVal <= 700 || !value) {
    return 'success'
  }

  if (parseVal <= 1000) {
    return 'yellow'
  }

  if (parseVal <= 1500) {
    return 'orange'
  }

  return 'danger'
}

export const parseInfoToString = (data: string, prefix = '--') => {
  return data.split(prefix).reduce((obj, item) => {
    const spitItem = item.split('=')
    return { ...obj, [spitItem[0]]: spitItem[1] }
  }, {})
}
